import { useEffect, useState } from 'react';

import {
    IExternalContentsSelectorQueryVariables,
    IExtraCategoryFilterInput,
} from 'graphql/types';
import { DEFAULT_PAGINATION_SETTINGS } from 'common/hooks/usePagination';
import { TFilterBarItem } from 'common/types';
import {
    extraCategoryFiltersAreEqual,
    getExtraCategoryInputVariables,
} from 'organisation/utils/extraCategory';

interface IProps {
    paginationVariables?: {
        offset: number;
        first: number;
    };
    searchQueryParam?: string;
    selectedFilters: TFilterBarItem[];
}

export const useExternalContentQueryVariables = ({
    paginationVariables,
    searchQueryParam,
    selectedFilters,
}: IProps) => {
    const [queryVariables, setQueryVariables] = useState<
        IExternalContentsSelectorQueryVariables & {
            extraCategories?: IExtraCategoryFilterInput[];
        }
    >({
        q: '',
        ...DEFAULT_PAGINATION_SETTINGS,
    });

    useEffect(() => {
        const newQueryVariables = {
            ...paginationVariables,
            q: searchQueryParam,
            extraCategories: getExtraCategoryInputVariables(selectedFilters),
        };

        const { q, offset, first, extraCategories } = queryVariables;

        if (
            q === newQueryVariables.q &&
            offset === newQueryVariables.offset &&
            first === newQueryVariables.first &&
            extraCategoryFiltersAreEqual(
                extraCategories || [],
                newQueryVariables.extraCategories
            )
        ) {
            return;
        }

        setQueryVariables({
            ...queryVariables,
            ...newQueryVariables,
            offset: q !== newQueryVariables.q ? 0 : newQueryVariables.offset,
        });
    }, [
        queryVariables,
        paginationVariables,
        searchQueryParam,
        selectedFilters,
    ]);

    return { queryVariables };
};
